import WebOrganisationModelBase from '../_generated/modelBases/web-organisation-model-base';

export default class WebOrganisationModel extends WebOrganisationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
